<template lang="pug">
validation-observer(ref="obs" v-slot="{ invalid, handleSubmit }")
  v-form(ref="form")
    validation-provider(
      ref="innField"
      rules="required|integer|inn"
      name="ИНН"
      vid="payment_inn"
      v-slot="{ errors }"
    )
      v-text-field(
        v-model.trim="organization.payment_inn"
        name="payment_inn"
        label="ИНН"
        type="number"
        :error-messages="errors"
        filled
        rounded
        :loading="loadingInn"
        :counter="12"
      )
    validation-provider(
      rules="required"
      name="Краткое наименование"
      v-slot="{ errors }"
    )
      v-text-field(
        v-model.trim="organization.short_name"
        name="short_name"
        disabled
        label="Краткое наименование"
        :error-messages="errors"
        filled
        rounded
      )
    validation-provider(
      rules="required"
      name="Полное наименование"
      v-slot="{ errors }"
    )
      v-text-field(
        v-model.trim="organization.full_name"
        disabled
        name="full_name"
        label="Полное наименование"
        :error-messages="errors"
        filled
        rounded
      )
    validation-provider(
      rules="required"
      name="Фактический адрес"
      vid="address_actual"
      v-slot="{ errors }"
    )
      v-text-field(
        v-model="organization.address_actual"
        disabled
        name="address_actual"
        label="Фактический адрес"
        :error-messages="errors"
        filled
        rounded
      )
  v-btn(
    color="success"
    class="ml-2 px-5 text-uppercase"
    @click="handleSubmit(signUp)"
    :disabled="invalid"
    :loading="loadingBtn"
    depressed
    block
    rounded
  ) Зарегистрироваться

</template>

<script>
import OrganizationTypeSelect from '@/components/InputFields/organization/OrganizationTypeSelect.vue';

export default {
  name: 'SignUpForm',
  components: {
    OrganizationTypeSelect,
  },
  props: {
    regionData: { type: Object, default: null },
    personalData: { type: Object, default: null },
  },
  data() {
    return {
      timezoneItems: [],
      organization: {
        short_name: '',
        full_name: '',
        address_actual: '',
      },
      dadata: {},
      loadingBtn: false,
      loadingInn: false,
      timezones: [],
    };
  },
  watch: {
    'organization.payment_inn': async function (val) {
      await this.$refs.innField.validate();
      if (String(val) > 1 && this.$refs.innField.errors.length === 0) this.sendInn();
    },
  },
  async created() {
    const { data } = await this.$api.system.getTimezoneList();
    this.timezones = data.data;
  },
  methods: {
    async sendInn() {
      this.loadingInn = true;
      await this.$rHandler(
        this.$api.auth.sendInn(this.organization.payment_inn),
        ({ data }) => {
          const dadata = data.data.suggestions;
          if (dadata.length) {
            this.organization.short_name = dadata[0].data.name.short_with_opf; // короткое имя
            this.organization.full_name = dadata[0].data.name.full_with_opf; // полное имя
            this.organization.address_actual = dadata[0].data.address.unrestricted_value; //
          }
          return data;
        },
        (resp) => resp,
        this.$refs.obs,
      );
      this.loadingInn = false;
    },
    async signUp() {
      this.loadingBtn = true;

      const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
      const editItem = {
        ...this.personalData,
        settings_region_id: this.regionData.region.id,
        settings_municipality_id: this.regionData.municipality.id,
        organization: this.organization,
        settings_time_zone_id: this.timezones.find((el) => timeZone === el.zone).id,
      };

      await this.$rHandler(
        this.$api.auth.registerOrganization(editItem),
        (response) => {
          this.$emit('done', response.data);
          return response;
        },
        () => {},
        this.$refs.obs,
      );
      this.loadingBtn = false;
    },
  },
};
</script>
